import React from 'react';
import wingsFeature from '../assets/wings-feature.png';
import drinkFeature from '../assets/drink-feature.png';
import NeonDivider from './NeonDivider';

const FeaturedSection = () => {
  return (
    <section className="py-20 px-4">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-logoSans text-ivory mb-4">
            FEATURED FAVORITES
          </h2>
          <p className="text-gray text-lg max-w-2xl mx-auto">
            Our signature wings and craft cocktails that put Billy's WingCo 
            on the map. Bold flavors under neon lights.
          </p>
        </div>

        <NeonDivider color="neonBlue" />

                <div className="grid lg:grid-cols-2 gap-8 sm:gap-12 items-center">
          {/* Wings Feature */}
          <div className="relative group">
            <div className="relative overflow-hidden rounded-2xl">
              <img
                src={wingsFeature}
                alt="Billy's signature wings platter"
                loading="lazy"
                className="w-full h-64 sm:h-80 lg:h-96 object-cover transition-transform duration-500
                           group-hover:scale-105"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/20 to-transparent" />
                                <div className="absolute bottom-4 sm:bottom-6 left-4 sm:left-6 right-4 sm:right-6">
                    <h3 className="text-xl sm:text-2xl md:text-3xl font-logoSans text-ivory mb-2">
                      LEGENDARY WINGS
                    </h3>
                    <p className="text-gray text-xs sm:text-sm leading-relaxed mb-3 sm:mb-4">
                      Hand-tossed in our signature sauces, served with fresh carrots
                      and house-made blue cheese. The wings that made Billy famous.
                    </p>
                    <a
                      href="#menu"
                      className="inline-flex items-center bg-neonRed text-white px-4 py-3
                                 rounded-lg font-semibold shadow-neonRed hover:animate-flicker
                                 hover:-translate-y-0.5 transition-all duration-200 text-sm sm:text-base
                                 min-h-[44px]"
                    >
                      Order Wings
                      <svg className="w-4 h-4 ml-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
                      </svg>
                    </a>
                  </div>
            </div>
          </div>

                    {/* Drinks Feature */}
          <div className="relative group">
            <div className="relative overflow-hidden rounded-2xl">
              <img
                src={drinkFeature}
                alt="Billy's craft margarita cocktail"
                loading="lazy"
                className="w-full h-64 sm:h-80 lg:h-96 object-cover transition-transform duration-500
                           group-hover:scale-105"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/20 to-transparent" />
                                <div className="absolute bottom-4 sm:bottom-6 left-4 sm:left-6 right-4 sm:right-6">
                    <h3 className="text-xl sm:text-2xl md:text-3xl font-logoSans text-ivory mb-2">
                      BILLY'S MARG
                    </h3>
                    <p className="text-gray text-xs sm:text-sm leading-relaxed mb-3 sm:mb-4">
                      Tequila, triple sec, lime juice - Simple, classic, and always a crowd-pleaser.
                    </p>
                    <a
                      href="#menu"
                      className="inline-flex items-center bg-neonBlue text-black px-4 py-3
                                 rounded-lg font-semibold shadow-neonBlue hover:animate-flicker
                                 hover:-translate-y-0.5 transition-all duration-200 text-sm sm:text-base
                                 min-h-[44px]"
                    >
                      Order Drinks
                      <svg className="w-4 h-4 ml-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
                      </svg>
                    </a>
                  </div>
            </div>
          </div>
        </div>

        {/* Call to Action */}
        <div className="text-center mt-16">
          <div className="max-w-2xl mx-auto">
            <h3 className="text-2xl md:text-3xl font-logoSans text-ivory mb-4">
              READY TO EXPERIENCE THE NEON GLOW?
            </h3>
            <p className="text-gray mb-8">
              Join us for an unforgettable night of legendary wings, craft cocktails, 
              and electric atmosphere. Same Billy, bold new attitude.
            </p>
            <div className="flex flex-col sm:flex-row gap-4 justify-center">
              <a
                href="#order"
                className="bg-neonRed text-white px-8 py-3 rounded-lg font-semibold
                           shadow-neonRed hover:animate-flicker hover:-translate-y-0.5
                           transition-all duration-200 inline-flex items-center justify-center"
              >
                Order Online
              </a>
              <a
                href="#contact"
                className="border-2 border-neonBlue text-neonBlue px-8 py-3 rounded-lg 
                           font-semibold hover:bg-neonBlue hover:text-black hover:shadow-neonBlue 
                           hover:-translate-y-0.5 transition-all duration-200 inline-flex 
                           items-center justify-center"
              >
                Visit Us
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default FeaturedSection; 